// Modules
import React from 'react';
import { Element } from 'react-scroll';
import cx from 'classnames';
// Components
import OMInputWithLable from '../OMComponents/OMInputWithLable/OMInputWithLable';
// Helpers
import { contactUsUsage } from '../../constants';
import { emailRegexValidation } from '../../utils/validate';
// Styles
import * as styles from './ContactUsForm.scss';

const UserDetailsSection = properties => (
  <div
    className={cx(
      (properties.usage === contactUsUsage.agent || properties.usage === contactUsUsage.realtorPackages)
        ? styles.agentForm
        : styles.userDetailsSection,
      { [styles.realtorProperties]: properties.usage === contactUsUsage.realtorPackages }
    )}
  >
    <Element name="name" className={styles.contentRow}>
      <OMInputWithLable
        title={`${properties.translate('nameTitle')}`}
        name="name"
        placeholder={`${properties.translate('namePlaceholder')}`}
        field={{
          onChange: properties.handleChange,
          isInvalid: properties.fieldIsInvalid('name'),
          validate: value => !!value
        }}
        className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
        required
        isRtl={properties.isRtl}
      />
    </Element>
    <Element name="email" className={styles.contentRow}>
      <OMInputWithLable
        title={`${properties.translate('emailTitle')}`}
        name="email"
        placeholder={`${properties.translate('emailPlaceholder')}`}
        field={{
          onChange: properties.handleChange,
          isInvalid: properties.fieldIsInvalid('email'),
          showHoverTooltip: true,
          tooltipMessage: `${properties.translate('emailTooltipMessage')}`,
          isMobile: properties.isMobile,
          validate: emailRegexValidation
        }}
        className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
        required
        isRtl={properties.isRtl}
      />
    </Element>
    <div className={styles.contentRow}>
      <OMInputWithLable
        title={`${properties.translate('phoneTitle')}`}
        name="phone"
        placeholder={`${properties.translate('phonePlaceholder')}`}
        field={{
          onChange: (evt) => {
            const value = evt.target.value;
            evt.target.value = value.replace(/[\D]/g, '').slice(0, 10);
            properties.handleChange(evt);
          },
          isInvalid: properties.fieldIsInvalid('phone')
        }}
        className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
        required={properties.isPageForRealtor}
        isRtl={properties.isRtl}
      />
    </div>
    { (properties.usage === contactUsUsage.agent || properties.usage === contactUsUsage.realtorPackages) && (
      <div className={styles.contentRow}>
        <OMInputWithLable
          title={`${properties.translate('companyName')}`}
          name="companyName"
          placeholder={`${properties.translate('companyName')}`}
          field={{
            onChange: properties.handleChange,
            isInvalid: properties.fieldIsInvalid('companyName'),
            validate: value => !!value
          }}
          className={(properties.usage === contactUsUsage.projects) ? 'projectsContactUsForm' : 'contactUsForm'}
          required
          isRtl={properties.isRtl}
        />
      </div>
    ) }
  </div>
);

export default UserDetailsSection;
